export default __webpack_public_path__ + "637a11a33f84bc729bfe43fae0f73e2e.png";